import { find, get } from 'lodash'

export type RouteLimitAdministration =
	| 'is_admin'
	| 'is_team'
	| 'isAdminOrTeam'
	| 'is_karthago'
	| 'is_sync_failures'
	| 'is_access_rejections'
	| 'can_settings'
	| 'can_post'
	| 'can_update'
	| 'can_delete'

export type RouteLimitSubscriptionModule =
	| 'accounting'
	| 'invoicing'
	| 'review_documents'
	| 'buildings'
	| 'units'
	| 'documents'
	| 'persons'
	| 'role_permissions'
	| 'property_managers'
	| 'phone_numbers'
	| 'notes'
	| 'notifications'
	| 'handover_protocols'
	| 'meters'
	| 'reports'
	| 'records'
	| 'craftsman_tasks'
	| 'cis'
	| 'tasks'
	| 'faqs'

export type RouteLimitSubscriptionMethod =
	| 'user_normal'
	| 'notification_welcome'
	| 'notification_lost_password'
	| 'notification_damage_report'
	| 'notification_message'
	| 'notification_note'
	| 'notification_meter'
	| 'notification_document'
	| 'notification_handover'
	| 'notification_person_update'
	| 'notification_tos'
	| 'notification_ticket_history'
	| 'notification_consumption'
	| 'external_track_lean'

export type RouteLimitation =
	| RouteLimitAdministration
	| RouteLimitSubscriptionMethod
	| RouteLimitSubscriptionModule

export default {
	is_admin: 'is_admin',
	is_team: 'is_team',
	can_settings: 'can_settings',
	can_post: 'can_post',
	can_update: 'can_update',
	can_delete: 'can_delete',
	isAdminOrTeam: 'isAdminOrTeam',
	is_karthago: 'is_karthago',
	is_sync_failures: 'is_sync_failures',
	is_access_rejections: 'is_access_rejections',
	subModules: {
		accounting: 'accounting',
		invoicing: 'invoicing',
		review_documents: 'review_documents',
		buildings: 'buildings',
		units: 'units',
		documents: 'documents',
		persons: 'persons',
		role_permissions: 'role_permissions',
		property_managers: 'property_managers',
		phone_numbers: 'phone_numbers',
		notes: 'notes',
		notifications: 'notifications',
		handover_protocols: 'handover_protocols',
		meters: 'meters',
		reports: 'reports',
		records: 'records',
		craftsman_tasks: 'craftsman_tasks',
		cis: 'cis',
		tasks: 'tasks',
		faqs: 'faqs',
	},
	subMethods: {
		user_normal: 'user_normal',
		notification_welcome: 'notification_welcome',
		notification_lost_password: 'notification_lost_password',
		notification_damage_report: 'notification_damage_report',
		notification_message: 'notification_message',
		notification_note: 'notification_note',
		notification_meter: 'notification_meter',
		notification_document: 'notification_document',
		notification_handover: 'notification_handover',
		notification_person_update: 'notification_person_update',
		notification_tos: 'notification_tos',
		notification_ticket_history: 'notification_ticket_history',
		notification_consumption: 'notification_consumption',
		external_track_lean: 'external_track_lean',
	},
} as const

export function hasProperty(list: any, property: string, value: unknown) {
	const found = find(list, (item, key) =>
		typeof item === 'object'
			? typeof value !== 'undefined'
				? get(item, property) === value
				: get(item, property)
			: key === property &&
				(typeof value !== 'undefined' ? item === value : true)
	)
	return (
		typeof found !== 'undefined' &&
		(typeof found !== 'object' ? found > -1 : true)
	)
}
